<template>
  <div class="price-range-wise-recos">
    <!-- Header Section Outside -->
    <div class="header">
      Price Range Wise Recos
      <span class="view-all" @click="applyFilter()">View all ({{ selectedTabStocksCount }})</span>
    </div>

    <!-- Main Price Range Section -->
    <div class="price-range-recos">
      <!-- Tabs Section -->
      <div class="tabs">
        <button v-for="tab in tabs" :key="tab.value" :class="{ active: selectedTab === tab.value }" @click="handleTabChange(tab.value)">
          {{ tab.label }}
        </button>
      </div>
      <hr class="divider" />

      <!-- Stock Items Section -->
      <div v-for="(stock, index) in displayedStocks" :key="stock.id" v-if="stocks.length && !isRecoListLoading">
        <div class="stock-item" v-loading="isRecoListLoading" @click="openStockPopup(stock, 'recoPopup')">
          <div class="stock-left">
            <img :src="stock.stock_logo" class="stock-logo" />
            <div class="stock-details">
              <p class="stock-name">{{ stock.stock_name }}</p>
              <p class="remaining-target">Remaining Target</p>
              <p class="percentage">{{ stock.remaining_potential }}%</p>
            </div>
          </div>
          <div class="stock-right">
            <div class="timestamp-logo">
              <p class="timestamp">{{ formatTimestamp(stock.created_at) }}</p>
              <el-tooltip effect="dark" placement="top">
                <template #content>
                  <div>
                    <strong>{{ stock.user_detail.name }}</strong>
                    <br />
                    SEBI Reg: {{ stock.user_detail.sebi_regi_number }}
                  </div>
                </template>
                <div>
                  <img class="user-profile_pic" :src="serverHostName + '/Media/' + stock.user_detail.profile_pic" v-if="stock.user_detail.profile_pic" />
                  <img class="user-profile_pic" src="../assets/images/navBar/avatar.jpg" v-else />
                </div>
              </el-tooltip>
            </div>

            <div class="action-buttons">
              <!-- <button class="buy-sell" :style="{ backgroundColor: stock.reco === 'Buy' ? '#0ba042' : '#EA2526' }" @click.stop="openStockPopup(stock, 'trade')">
                {{ stock.reco }}
              </button> -->

              <div>
                <button class="buy-sell" :style="{ backgroundColor: stock.reco === 'Buy' ? '#0ba042' : '#EA2526' }" @click.stop="openStockPopup(stock, 'trade')" v-if="userProfile && !currentEnvironment.byPassLogin && !currentEnvironment.isStockAntsAuth && userProfile.utm_source != 'Fyers' && userProfile.utm_source != 'BlinkX' && userProfile.utm_source != 'AngelOne' && userProfile.utm_source != '5 Paisa' && userProfile.utm_source != 'Dhan' && userProfile.utm_source != 'Finvasia' && userProfile.utm_source != 'Zerodha'">
                  {{ stock.reco }}
                </button>

                <button v-else-if="currentEnvironment.byPassLogin && currentEnvironment.isHybridModel" class="buy-sell" :style="{ backgroundColor: stock.reco === 'Buy' ? '#0ba042' : '#EA2526' }" @click.stop="getTradeHostDetails()">
                  {{ stock.reco }}
                </button>

                <button v-else class="buy-sell" style="cursor: not-allowed" :style="{ backgroundColor: stock.reco === 'Buy' ? '#0ba042' : '#EA2526' }" disabled>
                  {{ stock.reco }}
                </button>
              </div>
              <img src="../assets/images/bookmark (3).svg" alt="Arrow Icon" class="watchlist-icon cursor-pointer" @click.stop="followReco(stock.id, index, 'FOLLOW')" v-if="!stock.is_reco_subscribe_for_notification" />
              <img src="../assets/images/Filled bookmark.svg" alt="Arrow Icon" class="watchlist-icon cursor-pointer" @click.stop="followReco(stock.id, index, 'UNFOLLOW')" v-else />
            </div>
          </div>
        </div>
        <!-- Divider Line, but not for the 3rd item -->
        <hr v-if="index < displayedStocks.length - 1" class="divider" />
      </div>
      <NoDataFound v-if="!stocks.length && !isRecoListLoading" />
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import NoDataFound from '@/components/NoDataFound.vue';
import CripNotice from 'crip-vue-notice';
import moment from 'moment';

export default {
  props: ['stocksFromMainPage'],
  name: 'PriceRangeWiseRecos',

  components: {
    NoDataFound,
  },
  data() {
    return {
      tabs: [
        { label: 'Below ₹500', value: 'BELOW500' },
        { label: 'Above ₹500', value: '500TO1000' },
        { label: 'Above ₹1000', value: 'ABOVE1000' },
      ],
      selectedTab: 'BELOW500',
      stocks: [],
      serverHostName: serverHostName,
      isRecoListLoading: false,
      currentEnvironment: {},
    };
  },
  // created() {
  //   // Assign the prop value to the local data property on page loading
  //   if (this.stocksFromMainPage && Array.isArray(this.stocksFromMainPage)) {
  //     console.log(this.stocksFromMainPage);
  //     this.stocks = [...this.stocksFromMainPage]; // Use spread operator to avoid direct reference
  //   }
  // },
  watch: {
    stocksFromMainPage: {
      immediate: true, // Executes when the component is loaded
      handler(newValue) {
        if (newValue && Array.isArray(newValue)) {
          this.stocks = [...newValue];
        }
      },
    },
  },
  mounted() {
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

      this.hostUrl = this.currentEnvironment.hostUrl;
    }
  },
  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    displayedStocks() {
      return this.stocks.length >= 3 ? this.stocks.slice(0, 3) : this.stocks;
    },
    selectedTabStocksCount() {
      return this.stocks.length;
    },
  },
  methods: {
    getTradeHostDetails() {
      this.$store.commit('commitHybridBrokerLoginDialogVisibility', true);
    },
    openStockPopup(reco, action) {
      this.$emit('get_reco_details', reco, action);
    },
    followReco(recoId, index, action) {
      serverAddr
        .post('base/v1/trigger_notification_for_trading', {
          reco_id: recoId,
          event: 'EQ_TRADE_ON_MARKET_OPINION',
          watchlist_type: action,
        })
        .then((response) => {
          if (response.data.status) {
            if (action == 'FOLLOW') {
              if (index != undefined) {
                this.$set(this.displayedStocks[index], 'is_reco_subscribe_for_notification', true);
              }

              new CripNotice({
                title: 'Success',
                description: `You followed ${this.displayedStocks[index].symbol} recommendation`,
                type: 'success',
                duration: 2,
              });
            } else {
              if (index != undefined) {
                this.$set(this.displayedStocks[index], 'is_reco_subscribe_for_notification', false);
              }
              new CripNotice({
                title: 'Success',
                description: `You unfollowed ${this.displayedStocks[index].symbol} recommendation`,
                type: 'success',
                duration: 2,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    applyFilter() {
      this.$router.push(`/experts-past-recommendations?price_range=${this.selectedTab}`);
    },
    formatTimestamp(timestamp) {
      return moment(timestamp).format('MMM DD, YYYY, h:mm A');
    },
    handleTabChange(tabValue) {
      this.selectedTab = tabValue;
      // console.log(tabValue);

      this.getPriceRangeWiseRecommendation(); // data when tab changes
    },
    getPriceRangeWiseRecommendation() {
      this.isRecoListLoading = true;

      serverAddr
        .get(`/recommendation/v1/price_range_wise_recommendation?cmp_range=${this.selectedTab}`)
        .then((response) => {
          if (response.data.status) {
            this.stocks = response.data.data;
          } else {
            this.stocks = [];
          }
        })
        .catch((error) => {
          console.error('Error fetching recommendations:', error);
          this.stocks = [];
        })
        .finally(() => {
          this.isRecoListLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.price-range-wise-recos {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 10px;
    color: #000000;

    .view-all {
      font-size: 14px;
      font-weight: 500;
      color: #2d2e8d;
      text-decoration: none;
      cursor: pointer;
      transition: color 0.3s ease;

      &:hover {
        color: #0e4bf1;
      }
    }
  }

  .price-range-recos {
    padding: 8px;
    background-color: #ffffff;
    border-radius: 10px;
    min-height: 287px;

    .tabs {
      display: flex;
      gap: 20px;

      button {
        background: none;
        border: none;
        font-size: 15px;
        font-weight: 500;
        color: #000000;
        padding: 10px;
        cursor: pointer;
        position: relative;

        &.active {
          font-weight: 500;
          color: #000000;

          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: #2d2e8d;
            position: absolute;
            bottom: -1px;
            left: 0;
          }
        }
      }
    }

    .divider {
      border: none;
      border-top: 1px solid #ddd;
      margin: 0px;
    }

    .stock-item {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 10px;
      background-color: #ffffff;
      cursor: pointer;

      .stock-left {
        display: flex;
        align-items: flex-start;
        gap: 15px;

        .stock-logo {
          width: 35px;
          height: 35px;
          border-radius: 50%;
        }

        .stock-details {
          display: flex;
          flex-direction: column;

          .stock-name {
            font-size: 13px;
            font-weight: 600;
            margin: 0px;
            color: #000000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 170px;
          }

          .remaining-target {
            font-size: 10px;
            font-weight: 500;
            color: #878787;
            margin: 5px 0;
          }

          .percentage {
            font-size: 15px;
            font-weight: 600;
            color: #0ba042;
            margin: 0px 0px 5px 0px;
          }
        }
      }

      .stock-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .timestamp-logo {
          display: flex;
          align-items: center;

          .timestamp {
            font-size: 10px;
            font-weight: 500;
            color: #5e5e5e;
            margin-right: 10px;
          }

          .user-profile_pic {
            width: 25px;
            height: 25px;
            border-radius: 50%;
          }
        }

        .action-buttons {
          display: flex;
          align-items: center;
          gap: 10px;

          .buy-sell {
            padding: 5px 12px;
            width: 55px;
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            cursor: pointer;
          }

          .watchlist-icon {
            width: 25px;
            height: 25px;
            cursor: pointer;
          }
        }
      }
    }
  }

  @media (max-width: 1192px) {
    .price-range-recos {
      .stock-item {
        .stock-left {
          .stock-details {
            .stock-name {
              max-width: 80px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1050px) {
    .price-range-recos {
      .stock-item {
        .stock-left {
          .stock-details {
            .stock-name {
              max-width: 150px;
            }
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    .price-range-recos {
      .tabs {
        button {
          font-size: 13px;
        }
      }

      .stock-item {
        .stock-left {
          .stock-details {
            .stock-name {
              font-size: 11px;
              max-width: 110px;
            }

            .remaining-target {
              font-size: 10px;
            }

            .percentage {
              font-size: 13px;
            }
          }
        }

        .stock-right {
          .timestamp-logo {
            .timestamp {
              font-size: 8px;
            }
          }

          .action-buttons {
            .buy-sell {
              font-size: 11px;
            }
          }
        }
      }
    }
  }
}
</style>
